import React, { useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { brand, navItems } from '../mock';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-40 bg-[#0a1120]/85 backdrop-blur-md border-b border-white/5">
      <div className="max-w-[1320px] mx-auto px-6 h-[76px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-11 h-11 rounded-md bg-[#0f1a2f] border border-white/10 flex items-center justify-center text-orange-400 font-mono text-[13px] tracking-tight group-hover:border-orange-400/50 transition-colors">
            +000
          </div>
          <div className="leading-tight">
            <div className="flex items-center gap-2">
              <span className="text-white font-serif text-xl tracking-tight">{brand.name}</span>
              <span className="text-[10px] font-mono tracking-[0.18em] px-1.5 py-0.5 rounded bg-orange-500/15 text-orange-300 border border-orange-500/25">{brand.tag}</span>
            </div>
            <div className="text-[11px] text-slate-400 mt-0.5">{brand.subtitle}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1 bg-white/[0.02] border border-white/5 rounded-lg px-1.5 py-1.5">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `px-3.5 py-1.5 text-sm rounded-md transition-all duration-200 ${
                  isActive || loc.pathname === item.path
                    ? 'bg-orange-500/15 text-orange-300 shadow-inner'
                    : 'text-slate-300 hover:text-white hover:bg-white/5'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/contact"
            className="hidden md:inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-400 text-[#0a1120] font-semibold text-sm px-4 py-2.5 rounded-md transition-colors"
          >
            ENGAGE ADVISORY <ArrowUpRight className="w-4 h-4" />
          </Link>
          <button className="lg:hidden p-2 text-slate-300" onClick={() => setOpen(!open)}>
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/5 bg-[#0a1120]">
          <div className="px-6 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm rounded-md ${
                    isActive ? 'bg-orange-500/15 text-orange-300' : 'text-slate-300 hover:bg-white/5'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
